import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, BrowserRouter, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { registerationRoutes, RestrictedRoutes } from 'routing/RoutesConfig';
import { hasPermission } from 'constants/Helpers';
import { getFromLocalStorage } from 'helpers/LocalStorage';
// Components
import Header from 'components/common/Header';
import Tabs from 'components/common/Tabs';
// urls
import {
  getHomePageUrl,
  getLoginPageUrl,
  getOrdersPageUrl,
  getProductionHomePage,
} from 'constants/AppUrls';
// routing
import RestrictedRoute from 'routing/RestrictedRoute';
import RegistrationRoute from 'routing/RegistrationRoute';
// selectors
import { getIsLoggedIn, getPermissionsData } from 'store/app/AppSelectors';
// actions
import { getPermissions } from 'store/app/AppActions';
import {
  setWebSocketConnection,
  fetchExpressOrdersCount,
  setExpressOrdersWebSocketConnection,
} from './store/app/AppActions';
function RequiredAuth({ isLoggedIn, homePath, redirectTo }) {
  return isLoggedIn ? <Navigate to={homePath} /> : <Navigate to={redirectTo} />;
}

function App() {
  const isLoggedIn = useSelector((state) => getIsLoggedIn({ state }));
  const permissions = useSelector((state) => getPermissionsData({ state }));
  const dispatch = useDispatch();
  const authToken = getFromLocalStorage('token');

  useEffect(() => {
    if (authToken) {
      dispatch(setWebSocketConnection());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchExpressOrdersCount());
      dispatch(setExpressOrdersWebSocketConnection());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getPermissions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);
  return (
    <BrowserRouter>
      <HelmetProvider>
        <Helmet>
          <body className="App hf-App"></body>
        </Helmet>
        <div>
          <div className="page-wrapper page-body">
            <div className="page-body-wrapper">
              {isLoggedIn && (
                <>
                  <Header />
                  {hasPermission(permissions, 'florist_production', 'view') && (
                    <Tabs>
                      <div label="Orders" url={getOrdersPageUrl()} />
                      <div label="Production" url={getProductionHomePage()} />
                    </Tabs>
                  )}
                </>
              )}
              <Routes>
                <Route
                  path="/"
                  element={
                    <RequiredAuth
                      isLoggedIn={isLoggedIn}
                      homePath={getHomePageUrl()}
                      redirectTo={getLoginPageUrl()}
                    />
                  }
                />
                {registerationRoutes.map((route, i) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <RegistrationRoute path={route.path} component={route.component} key={i} />
                    }
                  />
                ))}
                {RestrictedRoutes().map((route, i) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <RestrictedRoute
                        path={route.path}
                        component={route.component}
                        key={i}
                        exact={route.exact}
                      />
                    }
                  />
                ))}
              </Routes>
            </div>
          </div>
          <ToastContainer theme="colored" icon={false} />
        </div>
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;
